export default "__VITE_ASSET__MgyyCwiP__"